import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useRegisterAccounts */
export type TypeRegisterAccontsParams = {
  /** 로그인 아이디 */
  username: string;
  /** 비밀번호 */
  password: string;
  /** 이름 */
  name: string;
  /** 휴대전화 번호 */
  phoneNumber: string;
  /** 인증번호 */
  verificationCode: string;
  /** 채용 정보 문자 수신 동의 */
  allowRecruit: boolean;
  /** 야간 채용 안내 문자 수신 동의 */
  allowNightTime: boolean;
};

/** @category useRegisterAccounts */
export type TypeRegisterAccontsResponse = {
  code: string;
  message: string;
  data: {
    /** 회원 고유 아이디 */
    laborAccountId: string;
  };
};

/**
 * @description 회원가입 요청 api에 사용되는 커스텀 훅
 */
export const useRegisterAccounts = () => {
  const endpoint = '/labor-accounts';

  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRegisterAccontsParams) => {
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestRegisterAccounts = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRegisterAccontsParams;
    onSuccess?: (res: TypeRegisterAccontsResponse) => Promise<void>;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(
      () => mutateAsync(params),
      async (res) => {
        await onSuccess?.(res);
      },
      onError
    );
  };

  return requestRegisterAccounts;
};
